//
export default [
    {
        text: 'código proveedor',
        value: 'provider_product_code',
        input: {
            type: 'text-field',
        },
        width: '15%',
    },
    {
        text: 'código interno',
        value: 'internal_code',
        width: '15%',
    },
    {
        text: 'códigos upc',
        value: 'upc_codes',
        component: {
            type: 'chip-list',
        },
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'stock',
        value: 'stock',
        align: 'right',
        width: '15%',
    },
    {
        text: 'cantidad',
        value: 'quantity',
        align: 'right',
        format: 'float',
        input: {
            reverse: true,
            type: 'float-field',
        },
        width: '15%',
    },
]
